import { ChevronRight } from 'lucide-react';
import { cloneElement, isValidElement, type ReactElement, type ReactNode } from 'react';
import { Icon } from '../Icon/Icon';
import s from './Breadcrumb.module.css';

export type BreadcrumbItem = {
  key: string;
  label: string;
  link?: ReactElement<{ className?: string; children?: ReactNode }>;
  href?: string;
};

/** Minimal trail (desktop sub-pages). The last item is the current page. */
export function Breadcrumb({ items }: { items: BreadcrumbItem[] }) {
  return (
    <nav aria-label="Breadcrumb">
      <ol className={s.list}>
        {items.map((it, i) => {
          const last = i === items.length - 1;
          const inner = last ? (
            <span aria-current="page" className={s.current}>
              {it.label}
            </span>
          ) : it.link && isValidElement(it.link) ? (
            cloneElement(it.link, { className: s.link, children: it.label } as object)
          ) : (
            <a href={it.href} className={s.link}>
              {it.label}
            </a>
          );
          return (
            <li key={it.key} className={s.item}>
              {inner}
              {last ? null : <Icon icon={ChevronRight} size="sm" className={s.sep} />}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
